// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__10oiD","ranges":"BmiRanges_ranges__sKxPo"};